module.exports = "/davinci/assets/69d541d97635e05ea90e9e5ff80dbfd7.png";